import { render, staticRenderFns } from "./PublicStats.vue?vue&type=template&id=64e08bfe&scoped=true"
import script from "./PublicStats.vue?vue&type=script&lang=js"
export * from "./PublicStats.vue?vue&type=script&lang=js"
import style0 from "./PublicStats.vue?vue&type=style&index=0&id=64e08bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e08bfe",
  null
  
)

export default component.exports